import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

export function resetHasEditPendingApproval<TCache = NormalizedCacheObject>(
  client: ApolloClient<TCache>,
  adId: string
) {
  client.cache.modify({
    id: client.cache.identify({ __typename: 'Ad', id: adId }),
    fields: {
      hasEditPendingApproval: () => false,
    },
    broadcast: true,
  });
}
